import { c as _c } from "react/compiler-runtime";
import { useListingTypePrescreen } from "./useListingTypePrescreen";
import { SelectableIconTile } from "@/components/atoms/SelectableIconTile";
export function ListingTypePrescreen() {
  const $ = _c(15);
  const {
    t,
    options,
    soonOptions,
    selectListingType
  } = useListingTypePrescreen();
  let t0;
  if ($[0] !== options || $[1] !== selectListingType || $[2] !== t) {
    let t1;
    if ($[4] !== selectListingType || $[5] !== t) {
      t1 = option => <SelectableIconTile key={option.value} icon={option.icon} title={t(option.labelKey)} description={t(option.descriptionKey)} onClick={() => selectListingType(option.value)} />;
      $[4] = selectListingType;
      $[5] = t;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = options.map(t1);
    $[0] = options;
    $[1] = selectListingType;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[7] !== soonOptions || $[8] !== t) {
    let t2;
    if ($[10] !== t) {
      t2 = option_0 => <SelectableIconTile key={option_0.labelKey} soon={true} soonLabel={t("soon")} icon={option_0.icon} title={t(option_0.labelKey)} description={t(option_0.descriptionKey)} />;
      $[10] = t;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t1 = soonOptions.map(t2);
    $[7] = soonOptions;
    $[8] = t;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[12] !== t0 || $[13] !== t1) {
    t2 = <div className="flex flex-col flex-1 w-full items-center justify-center p-4 gap-6" data-sentry-component="ListingTypePrescreen" data-sentry-source-file="ListingTypePrescreen.tsx"><div className="grid sm:grid-cols-2 gap-4 w-full max-w-[520px]">{t0}{t1}</div></div>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}